/**
 * Barra superior da home, só abaixo de `nav` (900px), onde a sidebar vira drawer.
 *
 * Substitui o antigo cabeçalho mobile (marca + atalho de Configurações): agora o
 * hambúrguer abre a sidebar inteira, e Configurações mora no rodapé dela.
 */

import React from 'react';
import { useTranslation } from 'react-i18next';
import MedverseLogo from './MedverseLogo';
import { MenuIcon } from './icons';

interface PlatformTopbarProps {
  onOpenNav: () => void;
  isNavOpen: boolean;
}

const PlatformTopbar: React.FC<PlatformTopbarProps> = ({ onOpenNav, isNavOpen }) => {
  const { t } = useTranslation();

  return (
    <div className="sticky top-0 z-30 flex items-center gap-3.5 border-b border-white/10 bg-mv-bg/80 px-4 py-3 backdrop-blur-md nav:hidden">
      <button
        type="button"
        onClick={onOpenNav}
        aria-label={t('platform.openMenu')}
        aria-expanded={isNavOpen}
        aria-controls="platform-nav"
        data-testid="platform-menu-button"
        className="grid h-[38px] w-[38px] place-items-center rounded-[9px] border border-white/10 bg-mv-surface text-mv-text transition-colors duration-200 ease-mv hover:bg-mv-surface-2 focus:outline-none focus-visible:ring-2 focus-visible:ring-mv-accent-hi"
      >
        <MenuIcon className="h-[18px] w-[18px]" />
      </button>
      <MedverseLogo compact />
    </div>
  );
};

export default PlatformTopbar;
